import React from "react";
import "../userAccountBriefInfo.css";

function BriefField({label, value, unit}) {
    const hasValue = value != null && value !== "";
    const display = hasValue ? (unit ? `${value} ${unit}` : value) : "—";

    return (
        <div className="user-account-brief-info__row">
            <span className="user-account-brief-info__label">{label}</span>
            <span className={`user-account-brief-info__value${hasValue ? "" : " is-empty"}`}>
                {display}
            </span>
        </div>
    );
}

function UserAccountDetail({userAccount, company}) {
    return (
        <div className="user-account-brief-info">
            <section className="user-account-brief-info__section">
                <h3 className="user-account-brief-info__title">사용자 업체정보</h3>
                <div className="user-account-brief-info__rows">
                    <BriefField label="업체명" value={company?.name} />
                    <BriefField label="대표전화" value={company?.employeeContact} />
                    <BriefField label="팩스번호" value={company?.fax} />
                    <BriefField label="홈페이지" value={company?.uri} />
                    <BriefField label="주소" value={company?.address} />
                    <BriefField label="업체 직원수" value={company?.userCount} unit="명" />
                    <BriefField label="유지보수 자산정보" value={company?.assetCount} unit="건" />
                    <BriefField label="자산 계약정보" value={company?.contractCount} unit="건" />
                    <BriefField label="부서명" value={userAccount?.department?.name} />
                </div>
            </section>
        </div>
    );
}

export default UserAccountDetail;
